import { API } from '../config/api';
import { DataService } from '../config/dataService/dataService';

class WorkStationsSettingsService {
  static async getSettings() {
    const { data } = await DataService.get(API.workStationsSettings.root);
    return {
      workStationsSettings: data.workStationsSettings,
    };
  }

  static async updateSettings(settingsData) {
    const { data } = await DataService.patch(API.workStationsSettings.root, settingsData);
    return {
      workStationsSettings: data.workStationsSettings,
    };
  }
}

export { WorkStationsSettingsService };
